import { CustomButton, CustomModal } from '@amili-v3/amili-v3-design';
import styled from 'styled-components';

export const BodyDropdownWrapper = styled.div`
  /* width: 280px;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 30px 25px;
  border-radius: 12px;
  gap: 15px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05); */
  padding: 30px 25px;
  padding-bottom: 15px;

  .ant-checkbox-group {
    flex-direction: column;

    label {
      padding: 8px 0;
    }
  }
`;

export const UploadModalWrapper = styled(CustomModal)`
  .ant-modal-body {
    .download-sample-file {
      display: flex;
      justify-content: space-between;
      border: 1px solid var(--light-gray);
      border-radius: 6px;
      padding: 10px 0 10px 10px;
      margin-bottom: 30px;

      .file-info {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
  }
`;

export const FilterKitTabWrapper = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;

  .ant-radio-group.ant-radio-group-solid.ant-radio-group-large {
    display: flex;
    gap: 10px;
    min-width: max-content;

    .ant-space {
      margin-bottom: 15px;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      background-color: var(--link);
      color: var(--white-gray);
    }

    .ant-radio-button-wrapper {
      display: flex;
      align-items: center;
    }

    label {
      border-radius: var(--default-border-radius);

      &:not(.ant-radio-button-wrapper-disabled) {
        background-color: var(--light-link);
        border: 1px solid var(--link);
        color: var(--link);
        padding-inline: 12px;
      }

      &:hover:not(.ant-radio-button-wrapper-disabled) {
        background-color: var(--default-hover-color);
        border-color: var(--default-hover-color);
        color: var(--white-gray);
      }

      &::before {
        background-color: transparent;
      }

      span:last-child {
        font-size: 14px;
        font-weight: 600;
      }

      .special-tab-tooltip {
        display: flex;

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 1px;
        }
        .kit-not-activated {
          background-color: var(--error);
        }
      }
    }
  }
`;

export const HistoryWrapper = styled.div`
  .title {
    font-weight: 500;
    margin-right: 5px;
  }
`;

export const PrintLabelItemTitle = styled.div`
  font-size: 14px;
  padding-left: 20px;
  margin-top: 10px;
`;

export const GridItem = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 10px 0;
`;

export const ModalBody = styled.div`
  width: 100%;
`;

export const ScrollBar = styled.div`
  max-height: 70vh;
  overflow: scroll;
`;

export const ExportButton = styled(CustomButton)`
  width: 100%;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
`;

export const ErrorCsvModalWrapper = styled.div`
  .title-error {
    display: flex;
    align-items: center;
    margin: 0.5rem auto;
    font-weight: bold;
    margin-left: 0.8rem;
  }
  .error-content {
    margin-left: 2rem;
  }
`;
